module.exports = __webpack_public_path__ + "img/laravel-banner.37dad853.webp";